import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  request: {
    isLoading: boolean;
    error: string | null;
  };
  list: {
    isLoading: boolean;
    hits: any[] | null;
    total: number | null;
    error: string | null;
  };
  one: {
    isLoading: boolean;
    data: Record<string, any> | null;
    error: string | null;
  };
  warehouse: {
    isLoading: boolean;
    hits: any[] | null;
    total: number | null;
    error: string | null;
  };
}

const initialState: InitialStateProps = {
  request: {
    isLoading: false,
    error: null,
  },
  list: {
    isLoading: false,
    hits: null,
    total: null,
    error: null,
  },
  one: {
    isLoading: false,
    data: null,
    error: null,
  },
  warehouse: {
    isLoading: false,
    hits: null,
    total: null,
    error: null,
  },
};

export const { actions: locationActions, reducer: locationReducer } = createSlice({
  name: 'location',
  initialState,
  reducers: {
    //Request
    setLocationRequestStart: (state) => {
      state.request = {
        isLoading: true,
        error: null,
      };
    },
    setLocationRequestSuccess: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },
    setLocationRequestFailure: (state, { payload }) => {
      state.request = {
        isLoading: false,
        error: payload.message,
      };
    },
    setLocationRequestDefault: (state) => {
      state.request = {
        isLoading: false,
        error: null,
      };
    },

    //List
    setLocationListRequest: (state) => {
      state.list = {
        isLoading: true,
        hits: null,
        total: null,
        error: null,
      };
    },
    setLocationListSuccess: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: payload.hits,
        total: payload.total,
        error: null,
      };
    },
    setLocationListFailure: (state, { payload }) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: payload.message,
      };
    },
    setLocationListDefault: (state) => {
      state.list = {
        isLoading: false,
        hits: null,
        total: null,
        error: null,
      };
    },

    //One
    setLocationOneRequest: (state) => {
      state.one = {
        isLoading: true,
        data: null,
        error: null,
      };
    },
    setLocationOneSuccess: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },
    setLocationOneFailure: (state, { payload }) => {
      state.one = {
        isLoading: false,
        data: null,
        error: payload.message,
      };
    },
    setLocationOneDefault: (state) => {
      state.one = {
        isLoading: false,
        data: null,
        error: null,
      };
    },

    //Warehouse
    setLocationWarehouseRequest: (state) => {
      state.warehouse = {
        isLoading: true,
        hits: null,
        total: null,
        error: null,
      };
    },
    setLocationWarehouseSuccess: (state, { payload }) => {
      state.warehouse = {
        isLoading: false,
        hits: payload.hits,
        total: payload.total,
        error: null,
      };
    },
    setLocationWarehouseFailure: (state, { payload }) => {
      state.warehouse = {
        isLoading: false,
        hits: null,
        total: null,
        error: payload.message,
      };
    },
    setLocationWarehouseDefault: (state) => {
      state.warehouse = {
        isLoading: false,
        hits: null,
        total: null,
        error: null,
      };
    },
  },
});
